import styled from 'styled-components';

export const AdBodyFormSearch = styled.div`
  padding: 10px 30px 5px 30px;
`;

export const AdBodyFormRole = styled.div`
  border-top: 1px solid #dce0e4;
  padding: 25px 30px 30px 30px;
  align-items: center;
  margin-top: 10px;
  display: flex;
`;
